/**
 * VIX Custom JS - Minimal
 * Only essential functionality, no jQuery dependency
 */

// Scroll-to-reveal header
(function() {
  var header = document.querySelector('.site-header');
  if (!header) return;

  var lastScrollY = 0;
  var scrollThreshold = 50;

  window.addEventListener('scroll', function() {
    var currentScrollY = window.scrollY;

    if (currentScrollY < scrollThreshold) {
      header.classList.remove('is-hidden');
      lastScrollY = currentScrollY;
      return;
    }

    if (currentScrollY > lastScrollY) {
      header.classList.add('is-hidden');
    } else {
      header.classList.remove('is-hidden');
    }

    lastScrollY = currentScrollY;
  }, { passive: true });
})();

// Size guide popup
(function() {
  document.addEventListener('click', function(e) {
    if (e.target.matches('.size-guide-link, .size-guide-link *, .pdp-size-guide-link, .pdp-size-guide-link *')) {
      document.querySelector('.size-popup')?.classList.toggle('active');
      document.body.classList.toggle('no-scroll');
    }
    if (e.target.matches('.size-popup__close, .size-popup__close *, .size-popup__backdrop')) {
      document.querySelector('.size-popup')?.classList.remove('active');
      document.body.classList.remove('no-scroll');
    }
  });
  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelector('.size-popup')?.classList.remove('active');
      document.body.classList.remove('no-scroll');
    }
  });
})();

// Mobile filter toggle (collection pages)
(function() {
  document.addEventListener('click', function(e) {
    if (e.target.matches('.mobile-facets__open, .mobile-facets__open *')) {
      document.body.classList.add('mobile-open', 'no-scroll');
      document.querySelector('.overlay')?.classList.add('active');
    }
    if (e.target.matches('.close-filter, .apply-btn')) {
      document.body.classList.remove('mobile-open', 'no-scroll');
      document.querySelector('.overlay')?.classList.remove('active');
    }
  });
})();

// Currency form submission
document.querySelectorAll('.shopify-currency-form select').forEach(function(el) {
  el.addEventListener('change', function(e) {
    e.target.form.submit();
  });
});

// FAQ Accordion
(function() {
  document.addEventListener('click', function(e) {
    var label = e.target.closest('.acnav-label');
    if (!label) return;

    e.preventDefault();
    var parent = label.closest('.set.has-children');
    if (!parent) return;

    var content = parent.querySelector('.acnav-list');
    if (!content) return;

    var isOpen = parent.classList.contains('is-open');

    // Close all other accordions in same container
    var container = parent.closest('.faqs-container');
    if (container) {
      container.querySelectorAll('.set.has-children.is-open').forEach(function(item) {
        if (item !== parent) {
          item.classList.remove('is-open');
          item.querySelector('.acnav-list').style.display = 'none';
        }
      });
    }

    // Toggle current
    if (isOpen) {
      parent.classList.remove('is-open');
      content.style.display = 'none';
    } else {
      parent.classList.add('is-open');
      content.style.display = 'block';
    }
  });
})();
